const fragment = `
  id
  name
  enableMultipleSelection
`;

export const createFloorGroupQuery = `
  mutation CreateFloorGroup(
    $input: CreateFloorGroupInput!
  ) {
    item: createFloorGroup(input: $input) {
      ${fragment}
    }
  }
`;

export const updateFloorGroupQuery = `
  mutation UpdateFloorGroup(
    $input: UpdateFloorGroupInput!
  ) {
    item: updateFloorGroup(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteFloorGroupQuery = `
  mutation DeleteFloorGroup(
    $id: Int!
  ) {
    item: deleteFloorGroup(id: $id) {
      ${fragment}
    }
  }
`;

export const sortFloorGroupsQuery = `
  mutation SortFloorGroups(
    $floorId: Int!,
    $ids: [Int!]!
  ) {
    items: sortFloorGroups(floorId: $floorId, ids: $ids) {
      ${fragment}
    }
  }
`;
